export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Aanmelden",
    "login.form.hint.user": "Gebruikersnaam",
    "login.form.hint.password": "Wachtwoord",
    "login.form.checkbox.remember-me": "Onthoud mij",
    "login.form.button.sign-in": "Aanmelden",
    "login.form.message.invalid-user-credentials": "Gebruikersnaam of wachtwoord is onjuist",
    "login.form.message.account-temporarily-locked": "Uw account is tijdelijk vergrendeld. Kom terug over 5 minuten",
    "login.form.message.user-required": "Voer een gebruikersnaam in",
    "login.form.message.password-required": "Voer een wachtwoord in",
    "login.form.button.forgot-password": "Wachtwoord vergeten?",
    "error.mfa-required.title": "2FA Instellen",
    "error.mfa-required.message1": "Twee-factor-authenticatie (2FA) is vereist om uw account te beschermen.",
    "error.mfa-required.message2": "U wordt doorgestuurd naar uw accountinstellingen in het Online Dashboard. Schakel 2FA in, volg de instructies voor het instellen en kom daarna hier terug.",
    "error.mfa-required.learnMore": "Meer informatie over 2FA",
    "error.mfa-required.continue": "Doorgaan",
    "error.root-admin-login.title": "Fout 403 – verboden",
    "error.root-admin-login.message": "U bent ingelogd als alleen-lezen beheerder. Als u toegang wilt krijgen tot de Web Recovery Console, moet u zich aanmelden als gebruiker van een klanttenant of als beheerder",
    "error.server-busy.message": "De server is bezet. Probeer het later opnieuw.",
    "error.network-connection.title": "Fout van de netwerkverbinding",
    "error.network-connection.message": "Controleer uw internetverbinding en probeer het opnieuw.",
    "error.internal-server-error.title": "Interne serverfout",
    "error.internal-server-error.message": "Neem contact op met de ondersteuning en geef de foutdetails op om de fout op te lossen:",
    "error.internal-server-error.copy.button": "Kopiëren"
};
